import { useEffect, useState } from "react";
import { Container } from "../styles";
import LoadingOverlay from "../../../components/LoadingOverlay";
import { T2 } from "../../../styles/titles";
import { CreditorTableData, CreditorFilterValues } from "./type";
import { CreditorFilter } from "./components/filter/filters";
import { CreditorsTable } from "./components/table/creditorsTable";
import CreditorsService from "./service/creditorsService";

const Creditors: React.FC = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [pageSize, setPageSize] = useState<number>(10);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [filterData, setFilterData] = useState<CreditorFilterValues>({});
  const [tableData, setTableData] = useState<CreditorTableData>({
    records: [],
    count: 0,
  });

  const creditorsService = new CreditorsService();

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const data = await creditorsService.getCreditorsPaged(
        currentPage,
        pageSize,
        filterData,
      );
      setTableData({
        records: data.queryable || [],
        count: data.rowCount || 0,
      });
    } catch (error) {
      console.error("Erro ao buscar credores: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Ao mudar o filtro, volta para a página 1
  useEffect(() => {
    setCurrentPage(1);
  }, [filterData]);

  // Busca dados sempre que filtro, página ou pageSize mudam
  useEffect(() => {
    fetchData();
  }, [filterData, currentPage, pageSize]);

  return (
    <Container>
      <LoadingOverlay show={isLoading} relative />

      <T2>Credores</T2>

      <CreditorFilter getFilters={(data) => setFilterData(data)} />

      <CreditorsTable
        data={tableData}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={setCurrentPage}
        onPageSizeChange={setPageSize}
        onRefresh={fetchData}
      />
    </Container>
  );
};

export default Creditors;
